import './style.css';
import '../../App.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppState, useAppDispatch } from '../../state/AppStateProvider';
import { fetchAllProducts } from '../allProducts/state/Actions';
import VideoShowcase from '../../components/VideoShowcase';
import HeroSection1 from './components/HeroSection1';
import HeroSection2 from './components/HeroSection2';
import HeroSection3 from './components/HeroSection3';
import HeroSection4 from './components/HeroSection4';
import LatestProjects from './components/LatestProjects';
import HowItWorks from './components/HowItWorks';
import HomeReviews from './components/HomeReviews';
import HomeFaq from './components/HomeFaq';
import { getActiveHeroConfig } from './heroConfig';
import { useSiteConfig } from '../../configs/siteConfig';

const HomePage = () => {
  useSiteConfig(); // the hero choice comes from Admin → Settings
  const { productState } = useAppState();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isLoading = productState?.isLoading || false;
  const products = productState?.products || [];
  const totalCount = productState?.productResponse?.totalCount;

  useEffect(() => {
    fetchAllProducts({ dispatch });
  }, [dispatch]);

  const goToProductPage = () => {
    navigate('/products');
  };

  // Render the appropriate hero section based on configuration
  const renderHeroSection = () => {
    const activeHero = getActiveHeroConfig();

    switch (activeHero) {
      case 1:
        return <HeroSection1 />;
      case 2:
        return <HeroSection2 />;
      case 3:
        return <HeroSection3 />;
      case 4:
        return (
          <HeroSection4
            products={products}
            totalCount={totalCount}
            isLoading={isLoading}
          />
        );
      case 'original':
        return (
          <div
            className="row"
            style={{
              minHeight: '85vh',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 5%',
              textAlign: 'center',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div
              className="col"
              style={{
                flexShrink: 1,
                maxWidth: '700px',
                height: 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <h1
                style={{
                  fontSize: 'clamp(28px, 6vw, 48px)',
                  fontWeight: '700',
                  lineHeight: '1.2',
                  color: '#ffffff',
                  margin: 0,
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                ONE STOP SOLUTION
              </h1>

              <h2
                style={{
                  fontSize: 'clamp(24px, 5vw, 42px)',
                  fontWeight: '600',
                  color: '#f0f9ff',
                  margin: 0,
                  textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                Free and Best Software Projects
              </h2>

              <span
                style={{
                  fontSize: 'clamp(16px, 3vw, 20px)',
                  color: 'rgba(255,255,255,0.9)',
                  maxWidth: '600px',
                  lineHeight: '1.6',
                  margin: '10px 0',
                  textAlign: 'center',
                  display: 'block',
                }}
              >
                Whether you're preparing for a college submission, exploring
                tutorials, or looking for real-world code samples,{' '}
                <strong>ProjectKart</strong> gives you instant access to
                high-quality projects with complete documentation.
              </span>

              <div
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  gap: '15px',
                }}
              >
                <button
                  type="button"
                  onClick={goToProductPage}
                  style={{
                    backgroundColor: '#2563eb',
                    color: '#fff',
                    padding: '12px 24px',
                    fontSize: '16px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                >
                  Explore Projects
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/contact')}
                  style={{
                    backgroundColor: 'transparent',
                    border: '2px solid #ffffffff',
                    color: '#ffffffff',
                    padding: '12px 24px',
                    fontSize: '16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <HeroSection4
            products={products}
            totalCount={totalCount}
            isLoading={isLoading}
          />
        ); // Default fallback
    }
  };

  return (
    <div
      className="app-layout"
      style={{ minHeight: '100vh', background: '#ffffff' }}
    >
      {renderHeroSection()}
      <LatestProjects
        products={products}
        totalCount={totalCount}
        isLoading={isLoading}
      />
      <HowItWorks />
      <HomeReviews products={products} />
      <VideoShowcase limit={3} />
      <HomeFaq />
    </div>
  );
};

export default HomePage;
